import { IAppState } from '../../common/state';

export function getConstructionStatus({ newbuildingInformation }: IAppState): string | null {
  return newbuildingInformation?.constructionStatus || null;
}
